import { AugmentDeviceData } from "Services/Utils/newDeviceMonitoring/types";

// currently, the device monitoring endpoint can return current_status === "down" for the hub while sensors are online
// thus using this function for hubs is not reliable and not recommended
export const isDeviceOffline = (device: AugmentDeviceData) => {
  return device.current_status === "down";
};
